import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { GiTakeMyMoney } from "react-icons/gi";
import { setDialog } from "../../../../../app/slices/invoiceSlice";
import InvoiceForm from "../../form";
import Permission from "../../../../../components/userPermission/userPermission";

const InvoiceHeader = () => {
  const dispatch = useDispatch();
  const _Invoice = useSelector((state) => state.invoice.invoice);

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            فواتير الشراء
          </Typography>
        }
        avatar={<GiTakeMyMoney size={20} />}
        action={
          <Permission permission="invoice_manager">
            <Button
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              اضافة فاتورة
            </Button>
          </Permission>
        }
      />
      {_Invoice.dialog ? <InvoiceForm /> : null}
    </Card>
  );
};

export default InvoiceHeader;
